import { ReactNode } from 'react';

/**
 * Centred message block for loading / empty / error states, keeping those
 * presentations consistent across pages.
 *
 * @param props.icon - Optional leading glyph.
 * @param props.title - Primary message.
 * @param props.children - Optional supporting content.
 * @param props.tone - Visual tone; `error` renders in the danger colour.
 */
export function StateMessage({
  icon,
  title,
  children,
  tone = 'neutral',
}: {
  icon?: ReactNode;
  title: string;
  children?: ReactNode;
  tone?: 'neutral' | 'error';
}) {
  return (
    <div className={`state state--${tone}`}>
      {icon && <div className="state__icon">{icon}</div>}
      <p className="state__title">{title}</p>
      {children && <div className="state__body">{children}</div>}
    </div>
  );
}
